<template>
    <div class="flex flex-col">
        <fieldset class="mb-6 grid gap-2 border p-4">
            <legend>Controls</legend>

            <label>
                Tooltip text
                <input
                    v-model="tooltipText"
                    class="my-2 w-full border border-teal-500 p-1 font-mono shadow-[0_0_5px] shadow-teal-500"
                />
            </label>

            <div>
                Tooltip location
                <div class="flex items-center gap-6 pt-1">
                    <label class="inline-flex items-center gap-2">
                        <input
                            v-model="tooltipLocation"
                            type="radio"
                            value="top"
                        />
                        Top
                    </label>
                    <label class="inline-flex items-center gap-2">
                        <input
                            v-model="tooltipLocation"
                            type="radio"
                            value="bottom"
                        />
                        Bottom
                    </label>
                    <label class="inline-flex items-center gap-2">
                        <input
                            v-model="tooltipLocation"
                            type="radio"
                            value="left"
                        />
                        Left
                    </label>
                    <label class="inline-flex items-center gap-2">
                        <input
                            v-model="tooltipLocation"
                            type="radio"
                            value="right"
                        />
                        Right
                    </label>
                </div>
            </div>

            <div class="grid grid-cols-2 gap-4">
                <label>
                    Open delay (ms)
                    <input
                        v-model="openDelay"
                        class="my-2 w-full border border-teal-500 p-1 font-mono shadow-[0_0_5px] shadow-teal-500"
                        type="number"
                    />
                </label>
                <label>
                    Close delay (ms)
                    <input
                        v-model="closeDelay"
                        class="my-2 w-full border border-teal-500 p-1 font-mono shadow-[0_0_5px] shadow-teal-500"
                        type="number"
                    />
                </label>
            </div>
        </fieldset>

        <div class="flex flex-col md:flex-row">
            <div class="w-full p-2 md:w-1/2">
                <h2>Basic tooltips</h2>
                <div class="grid gap-4 p-4">
                    <div>
                        <h3 class="mb-4">Icon button with tooltip</h3>
                        <div class="flex items-center">
                            <DsIconButton
                                :closeDelay
                                icon="fa-solid fa-xmark"
                                :openDelay
                                size="md"
                                :tooltipLocation
                                :tooltipText
                            />
                        </div>
                    </div>

                    <div>
                        <h3 class="mb-4">Simple element with tooltip</h3>
                        <div class="flex items-center">
                            <DsTooltip
                                :closeDelay
                                :openDelay
                                :tooltipLocation
                                :tooltipText
                            >
                                <div class="inline-block rounded border border-ds-primary-300 px-4 py-2">Hover over me</div>
                            </DsTooltip>
                        </div>
                    </div>
                </div>
            </div>

            <div class="w-full p-2 md:w-1/2">
                <h2>Advanced tooltips</h2>
                <div class="grid gap-4 p-4">
                    <div>
                        <h3 class="mb-4">Custom content tooltip</h3>
                        <div class="flex items-center">
                            <DsTooltip
                                :closeDelay
                                :openDelay
                                :tooltipLocation
                            >
                                <div class="inline-block rounded border border-ds-primary-300 px-4 py-2">With custom content</div>
                                <template #content>
                                    <div class="max-w-xs">
                                        <p class="mb-2 text-heading-sm">Custom tooltip content</p>
                                        <p class="text-body-sm">
                                            This tooltip demonstrates how you can use slots to create rich, custom-styled content
                                            within tooltips.
                                        </p>
                                    </div>
                                </template>
                            </DsTooltip>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import DsIconButton from '@/components/design-system/button/DsIconButton.vue';
import DsTooltip from '@/components/design-system/tooltip/DsTooltip.vue';
import { ref } from 'vue';
import type { TooltipPlacementType } from '../design-system';

const tooltipText = ref('This is a sample tooltip');
const tooltipLocation = ref<TooltipPlacementType>('top');
const openDelay = ref(250);
const closeDelay = ref(100);
</script>
